import ArrowRightIcon from "@/modules/common/components/ui-kit/icons/arrow-right-icon";
import { Stack, Typography, useTheme } from "@mui/material";

interface HeaderButtonProps {
  title: string;
  caption?: React.ReactNode;
  onClick: () => void;
  icon?: React.ReactNode;
  body?: React.ReactNode;
}

const HeaderButton = ({
  title,
  caption,
  onClick,
  icon,
  body,
}: HeaderButtonProps) => {
  const theme = useTheme();
  return (
    <Stack
      direction="column"
      padding={`0 ${theme.nawy.spacing.md}`}
      flex="1 0 0"
      borderRadius={theme.nawy.radius.xl}
      bgcolor={theme.nawy.colors.semantic.layer.primary}
    >
      <Stack
        direction="row"
        alignItems="center"
        gap={theme.nawy.spacing.md}
        width="100%"
        padding={`${theme.nawy.spacing.sm} 0`}
        onClick={onClick}
        sx={{ cursor: "pointer" }}
      >
        {icon && (
          <Stack
            width={20}
            height={20}
            alignItems="center"
            justifyContent="center"
          >
            {icon}
          </Stack>
        )}

        <Stack direction="column" gap={theme.nawy.spacing.xxs} flex="1">
          <Typography
            sx={{
              ...theme.nawy.typography.english.variants.body.md.semibold,
              color: theme.nawy.colors.semantic.text.primary,
            }}
          >
            {title}
          </Typography>
          {caption && (
            <Typography
              sx={{
                ...theme.nawy.typography.english.variants.body.sm.regular,
                color: theme.nawy.colors.semantic.text.secondary,
              }}
            >
              {caption}
            </Typography>
          )}
        </Stack>

        <Stack
          width={18}
          height={18}
          alignItems="center"
          justifyContent="center"
        >
          <ArrowRightIcon />
        </Stack>
      </Stack>
      {body && (
        <Stack width="100%" padding={`0 0 ${theme.nawy.spacing.sm} 0`}>
          {body}
        </Stack>
      )}
    </Stack>
  );
};

export default HeaderButton;
